import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { primaryBlue } from '../constants';

const useStyles = makeStyles((theme) => ({
  '@keyframes blinker': {
    from: { opacity: 0.9 },
    to: { opacity: 0.5 },
  },
  list: {
    width: 225,
    backgroundColor: 'white',
    height: '100%',
    // borderRadius: "0px 70px 20px 0px",
  },
  avoidTopAppBar: theme.mixins.toolbar,
  pointerDiv: {
    width: 45,
    bottom: 0,
    top: 0,
    left: 0,
    position: 'fixed',
    float: 'left',
    // zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: 35,
    },
  },
  drawIcon: {
    fill: '#191838',
    animationName: '$blinker',
    animationDuration: '1s',
    animationTimingFunction: 'ease',
    animationIterationCount: 'infinite',
  },
}));

export default function SwipeableTemporaryDrawer(props) {
  const sidebarOpen = props.sidebarOpen;
  const setSideBarOpen = props.setSideBarOpen;
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const userType = props.userType;

  const classes = useStyles();
  const [sidebarIndex, setSidebarIndex] = React.useState(
    localStorage.getItem('sidenavIndex')
  );
  const data = props.data;

  const toggleDrawer = () => {
    setSideBarOpen((prevState) => {
      return !prevState;
    });
  };
  const handleListItemClick = (event, index) => {
    setSidebarIndex(index);
    localStorage.setItem('sidenavIndex', index);
  };

  const list = () => (
    <div
      className={clsx(classes.list)}
      role="presentation"
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
    >
      <List
        style={{
          background: 'transparent !important',
        }}
      >
        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            marginBottom: '20px',
          }}
          className={clsx(classes.avoidTopAppBar)}
        >
          <h2 style={{ color: primaryBlue }}>Together</h2>
        </div>
        {data.map((each, index) => {
          if (
            userType === 2 &&
            (each.display === 'Create Host' ||
              each.display === 'View Users' ||
              each.display === 'Email List')
          ) {
            return null;
          }
          return (
            <ListItem
              button
              key={index}
              component={NavLink}
              to={each.url}
              activeStyle={
                sidebarIndex === index ? { backgroundColor: '#191838' } : {}
              }
              onClick={(event) => handleListItemClick(event, index)}
            >
              <ListItemIcon
                style={sidebarIndex === index ? { color: 'white' } : {}}
              >
                {each.icon}
              </ListItemIcon>
              <ListItemText
                style={sidebarIndex === index ? { color: 'white' } : {}}
              >
                {each.display}
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    </div>
  );

  return (
    <div>
      {userType === 3 || !userType ? null : (
        <React.Fragment>
          {/* <div
          onMouseEnter={toggleDrawer}
          className={classes.pointerDiv}
          onClick={toggleDrawer}
        >
          <LastPageIcon className={classes.drawIcon} />
        </div> */}
          <SwipeableDrawer
            swipeAreaWidth={12}
            anchor={'left'}
            open={sidebarOpen}
            onClose={toggleDrawer}
            onOpen={toggleDrawer}
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
          >
            {list()}
          </SwipeableDrawer>
        </React.Fragment>
      )}
    </div>
  );
}
